// Redux.
import { connect } from 'react-redux';

import { getDateString } from './timeHelper';
import { largeSourceImage } from './trackHelper';
import useWindowDimensions from './windowHelper';
import { AutoAwesome } from '@mui/icons-material';


const TrackInfoNoAiFeatures = (props) => {
    const {
        track,
    } = props;

    const { height, width } = useWindowDimensions();

    return (
        <div style={{ textAlign: 'center', width: `${Math.min(538, width)}px`}}>
                <div style={{ padding: '0px 20px 80px' }}>
                    <div style={{ padding: '20px' }}>
                        <img src={largeSourceImage(track.source.imageURL)} className='largeSourceImage' />
                    </div>
                    <div>
                        <div className='episodeTitleThreeLines'>
                            {track.source.title}
                        </div>
                        <div style={{ fontSize: '14px', color: 'rgba(0, 0, 0, .5)', paddingBottom: '6px' }}>
                            <span style={{ verticalAlign: 'middle' }}>
                                {getDateString(track.publishedDate)}
                            </span>
                        </div>
                    </div>
                    <div style={{ padding: '20px'}}>
                        <div style={{ fontSize: '13px', color: 'rgba(0, 0, 0, .5)', background: 'rgb(248, 248, 248)', borderRadius: '10px', padding: '10px 20px' }}>
                            <div>
                                <div>
                                    <AutoAwesome style={{ fontSize: '16px', verticalAlign: 'middle' }}/>
                                </div>
                                <div style={{ paddingTop: '6px' }}>
                                    Transcript, sections, and speakers will be available soon.
                                </div>
                            
                            </div>
                        </div>
                    </div>
                </div>
        </div >
    );
}

TrackInfoNoAiFeatures.propTypes = {

}

TrackInfoNoAiFeatures.defaultProps = {

}

const mapStateToProps = (state) => ({
    authenticated: state.user.authenticated,
})

const mapActionsToProps = {
}

export default connect(mapStateToProps, mapActionsToProps)(TrackInfoNoAiFeatures);
